import React from 'react';
import { Outlet } from 'react-router-dom';

const ShopRequests = () => {
  return <Outlet />;
};

export default ShopRequests;
